export class SearchCriteria {
  SearchText: string;
  SortOrder: string;
  SortOrderColumn: string;
  OffsetStart: number = 0;
  RowsPerPage: number;
}
